import React from 'react';
import { useTheme } from '../../ThemeContext.tsx';
import { Session, Message } from '../../types/chat.ts';
import HistoryLoading from './HistoryLoading.tsx';
import WelcomeScreen from './WelcomeScreen/index.tsx';
import ChatLog from './ChatLog.tsx';
import ChatInput from './ChatInput.tsx';

type ChatPanelProps = {
    chatAreaRef: React.RefObject<HTMLDivElement>;
    hasStartedChat: boolean;
    activeSession: Session | undefined;
    userInput: string;
    setUserInput: (value: string) => void;
    onSendMessage: (text: string) => void;
    onMessageUpdate?: (messageId: string, updates: Partial<Message>) => void;
    isProcessing: boolean;
    onStopProcessing: () => void;
    sessionId?: string | null;
    onChartRequest?: (query: string) => void;
};

const ChatPanel: React.FC<ChatPanelProps> = ({ chatAreaRef, hasStartedChat, activeSession, userInput, setUserInput, onSendMessage, onMessageUpdate, isProcessing, onStopProcessing, sessionId, onChartRequest }) => {
    const { colors } = useTheme();

    const isHistoryLoading = !!activeSession && activeSession.loaded === false;
    const showWelcome = !activeSession || (!isHistoryLoading && !hasStartedChat);

    return (
        <div className={`flex-1 flex flex-col overflow-hidden ${colors.bg.primary}`}>
            <div ref={chatAreaRef} className="flex-1 overflow-y-auto p-4 md:p-6">
                {isHistoryLoading ? (
                    <HistoryLoading />
                ) : showWelcome ? (
                    <WelcomeScreen onQuestionSelect={onSendMessage} />
                ) : (
                    <ChatLog
                        messages={activeSession!.messages}
                        chatAreaRef={chatAreaRef}
                        onMessageUpdate={onMessageUpdate}
                        sessionId={sessionId}
                        onChartRequest={onChartRequest}
                    />
                )}
            </div>

            <div className="flex-shrink-0 px-4 md:px-6 pb-2 bg-opacity-30" >
                <ChatInput
                    userInput={userInput}
                    setUserInput={setUserInput}
                    onSendMessage={onSendMessage}
                    hasStartedChat={!!activeSession && activeSession.messages.length > 0}
                    onRecommendedQuestionSelect={onSendMessage}
                    isProcessing={isProcessing}
                    onStopProcessing={onStopProcessing}
                />
                <p className={`-mt-2 text-xs font-medium text-center ${colors.text.tertiary}`}>
                    APAC D&A Hub - {new Date().getFullYear()}
                </p>
            </div>
        </div>
    );
};

export default ChatPanel;

